import {useRef} from 'react'
import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import _useAi from '../useAi.mjs'
import commonApiArgs from './commonApiArgs.mjs'
import useTokens from './useTokens.mjs'

export const useAi = ({...options}) => {
    const _ai = _useAi(options)
    const refWorkflowInstanceId = useRef('')

    const ai = {
        ..._ai,

        getWorkflowInstanceId() {
            return refWorkflowInstanceId.current
        },

        async run() {
            await _ai.run()
            const files = await this._uploadDraftFiles()

            const assistantMessages = this.messages.filter(
                m => false !== m.echo
            )

            const userMessage = {
                ...this.draft,
                files,
                role: 'user',
            }

            if (
                this.draft.content ||
                0 < files.length
            ) {
                this.addMessage(userMessage)
            }

            const chat = async () => {
                const steps = this.template.llmPromptTemplateItems.map(
                    ({
                        itemCode,
                        itemName,
                        pkid,
                        systemMessageTemplate: smt,
                        toolMessageTemplate,
                        userMessageTemplate,
                        ...e
                    }) => ({
                        ...e,
                        assistantMessages,
                        files: userMessage.files.map(e => e.fileId),
                        stepCode: itemCode,
                        stepId: pkid,
                        stepName: itemName,
                        systemMessage: this._getSystemMessage(smt),
                        userMessage: userMessage.content,
                    })
                )

                const {workflowInstanceId} = await runAsync(
                    async () => http.post(
                        '/ai/prepareChat',
                        {...commonApiArgs(this), steps},
                        {signal: this._getSignal()}
                    ),

                    {action: '准备会话'}
                )

                refWorkflowInstanceId.current = workflowInstanceId

                return http.post(
                    '/ai/chat',
                    {...commonApiArgs(this), steps},

                    {
                        signal: this._getSignal(),
                        streaming: true,
                    },
                )
            }

            const aiMessage = {
                content: '',
                role: 'assistant',
                status: 'pendding',
            }

            const msgId = this.addMessage(aiMessage)

            await runAsync(
                async () => {
                    try {
                        for await (const s of await chat()) {
                            this.updateMessage(msgId, msg => ({
                                ...msg,
                                content: msg.content + s,
                                status: 'receiving',
                            }))
                        }

                        this.updateMessage(msgId, msg => {
                            if (msg.content) {
                                return {...msg, status: 'done'}
                            }
                            else {
                                return {
                                    ...msg,
                                    content: 'ServerError: 大模型没有输出',
                                    status: 'error',
                                }
                            }
                        })
                    }
                    catch (err) {
                        if ('AbortError' === err.name) {
                            this.updateMessage(msgId, msg => ({
                                ...msg,
                                status: 'aborted',
                            }))
                        }
                        else {
                            const errMessage = err.detail ?
                                `\`\`\`js
                                ${JSON.stringify(err.detail, null, 4)}
                                \`\`\``
                                :
                                err.message

                            this.updateMessage(msgId, msg => ({
                                ...msg,
                                content: `${msg.content}\n${errMessage}`,
                                status: 'error',
                            }))

                            throw err
                        }
                    }
                    finally {
                        this.setIsRunning(false)
                    }
                },

                {
                    action: '执行',
                    loading: {show: false},
                }
            )
        },

        _getSystemMessage(template) {
            return template
        }
    }

    useTokens(ai)
    return ai
}
